import { P2Regular as P2RegularStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P2Regular typography style.
 */
export default function P2Regular({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P2RegularStyle, sx)} />;
}
